import Constants, { DATE_FORMATS } from '@/common/constants';
import { TDateFormats } from '@/common/types/date';

export const DATE_PICKER_MODES = ['date', 'yearMonth', 'year'] as const;

export type TDatePickerMode = (typeof DATE_PICKER_MODES)[number];

export type TDatePickerModePreset = {
  inputFormat: string;
  minimumView: 'day' | 'month' | 'year';
  startingView: 'day' | 'month' | 'year';
  defaultPlaceholder: string;
  parseFormats: TDateFormats[];
  emitFormat: TDateFormats;
  blurMomentFormat: TDateFormats;
  limitDisplayFormat: TDateFormats;
  inputMask: string;
};

export const DATE_PICKER_MODE_PRESETS: Record<TDatePickerMode, TDatePickerModePreset> = {
  date: {
    inputFormat: 'dd.MM.y',
    minimumView: 'day',
    startingView: 'day',
    defaultPlaceholder: 'дд.мм.гггг',
    parseFormats: [Constants.DATE_FORMATS['YYYY-MM-DD']],
    emitFormat: Constants.DATE_FORMATS['YYYY-MM-DD'],
    blurMomentFormat: Constants.DATE_FORMATS['DD.MM.YYYY'],
    limitDisplayFormat: Constants.DATE_FORMATS['DD.MM.YYYY'],
    inputMask: 'Dd.Mm.YYYy', // см. MONTH_INPUT_MASK_DEFINITIONS в inputMaskOptions.ts
  },
  yearMonth: {
    inputFormat: 'MM.y',
    minimumView: 'month',
    startingView: 'month',
    defaultPlaceholder: 'мм.гггг',
    parseFormats: [DATE_FORMATS['YYYY-MM'], DATE_FORMATS['YYYY-MM-DD']],
    emitFormat: DATE_FORMATS['YYYY-MM-DD'],
    blurMomentFormat: Constants.DATE_FORMATS['MM.YYYY'],
    limitDisplayFormat: Constants.DATE_FORMATS['MM.YYYY'],
    inputMask: 'Mm.YYYy',
  },
  year: {
    inputFormat: 'y',
    minimumView: 'year',
    startingView: 'year',
    defaultPlaceholder: 'гггг',
    parseFormats: [Constants.DATE_FORMATS.YYYY],
    emitFormat: Constants.DATE_FORMATS.YYYY,
    blurMomentFormat: Constants.DATE_FORMATS.YYYY,
    limitDisplayFormat: Constants.DATE_FORMATS.YYYY,
    inputMask: 'YYYy',
  },
};
